<template>
    <modal>
        <template v-slot:header>
             <span class='self-end cursor-pointer font-bold text-lg text-neutral-400  hover:scale-110' @click="modalClose">X</span><!--$emit('close-login-modal')-->
             <p class='self-center font-bold text-lg text-neutral-900'>Login</p>
        </template>

        <template v-slot:body>
            <login-form :is-modal="true"
                        @close-modal="modalClose"
                        @error="error"
            ></login-form>
        </template>

        <template v-slot:footer>
            <!--<div class="alert alert-danger" v-if="loginError">
                <p>There was an error, unable to sign in with those credentials.</p>
            </div>-->
        </template>
    </modal>
</template>

<script>
    import Modal from '../templates/Modal.vue';
    import LoginForm from '../form-comps/LoginForm.vue';

    export default {
        name: "login-form-modal",

        components: {
            Modal,
            LoginForm
        },

        data () {
            return {
                loginError: false,
            }
        },

        methods: {
            modalClose() {
                this.$emit('close-login-modal');
            },

            error () {
                this.loginError = true;
            }
        }

    }
</script>

<style scoped>

</style>